import React from 'react';
import './slider.css'
import '../fonts.css'


function SliderLeft(props) {
	return(
		<div className='slider-left-wrapper'>
			<div id="demo" className="carousel slide" data-ride="carousel">

				<ul className="carousel-indicators car-ind-sm">
					<li data-target="#demo" data-slide-to="0" className="active"></li>
					<li data-target="#demo" data-slide-to="1"></li>
					<li data-target="#demo" data-slide-to="2"></li>
				</ul>

				<div className="text-center carousel-inner">
					<div className="carousel-item active">
						<img className="custom-slider-img" src={props.img1} width="80%" alt=""/>
					</div>
					<div className="carousel-item">
						<img className="custom-slider-img" src={props.img2} width="80%" alt=""/>
					</div>
					<div className="carousel-item">
						<img className="custom-slider-img" src={props.img3} width="80%" alt=""/>
					</div>
				</div>

				<a className="carousel-control-prev" href="#demo" data-slide="prev">
					<span className="carousel-control-prev-icon"></span>
				</a>
				<a className="carousel-control-next" href="#demo" data-slide="next">
					<span className="carousel-control-next-icon"></span>
				</a>

			</div>
		</div>
	)
}

export function SliderLeftLong(props) {
	return(
		<div className='slider-long-left-wrapper pb-md-4 pb-lg-0'>
			<div id="demo3" className="carousel slide" data-ride="carousel">

				<ul className="carousel-indicators car-ind-lg">
					<li data-target="#demo3" data-slide-to="0" className="active"></li>
					<li data-target="#demo3" data-slide-to="1"></li>
					<li data-target="#demo3" data-slide-to="2"></li>
				</ul>

				<div className="text-center carousel-inner">
					<div className="carousel-item active">
						<img className="custom-slider-long-img" src={props.img1} width="80%" alt=""/>
					</div>
					<div className="carousel-item">
						<img className="custom-slider-long-img" src={props.img2} width="80%" alt=""/>
					</div>
					<div className="carousel-item">
						<img className="custom-slider-long-img" src={props.img3} width="80%" alt=""/>
					</div>
				</div>

				<a className="carousel-control-prev" href="#demo3" data-slide="prev">
					<span className="carousel-control-prev-icon"></span>
				</a>
				<a className="carousel-control-next" href="#demo3" data-slide="next">
					<span className="carousel-control-next-icon"></span>
				</a>

			</div>
		</div>
	)
}



export default SliderLeft;